var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Slider, Typography } from '@mui/material';
import { theme } from '../styles/theme';
var defaultRangeLabelFormat = function (startYear, endYear) {
    return "From ".concat(startYear, " to ").concat(endYear);
};
var defaultValueLabelFormat = function (value) { return "".concat(value); };
export var YearRangeSlider = function (_a) {
    var startYear = _a.startYear, endYear = _a.endYear, minYear = _a.minYear, maxYear = _a.maxYear, _b = _a.disabled, disabled = _b === void 0 ? false : _b, marks = _a.marks, onYearChange = _a.onYearChange, _c = _a.rangeLabelFormat, rangeLabelFormat = _c === void 0 ? defaultRangeLabelFormat : _c, _d = _a.valueLabelDisplay, valueLabelDisplay = _d === void 0 ? 'off' : _d, _e = _a.valueLabelFormat, valueLabelFormat = _e === void 0 ? defaultValueLabelFormat : _e, sliderSx = _a.sliderSx;
    var _f = useState([startYear, endYear]), value = _f[0], setValue = _f[1];
    var baseSliderStyles = {
        color: theme.palette.primary.main,
        '& .MuiSlider-thumb': {
            width: 16,
            height: 16,
        },
        '& .MuiSlider-markLabel': {
            fontSize: '0.75rem',
        },
    };
    var combinedSliderStyles = !sliderSx
        ? baseSliderStyles
        : Array.isArray(sliderSx)
            ? __spreadArray([baseSliderStyles], sliderSx, true)
            : [baseSliderStyles, sliderSx];
    useEffect(function () {
        setValue([startYear, endYear]);
    }, [startYear, endYear]);
    var handleChange = function (_, newValue) {
        if (Array.isArray(newValue)) {
            var newStartYear = newValue[0], newEndYear = newValue[1];
            setValue([newStartYear, newEndYear]);
        }
    };
    var handleChangeCommitted = function (_, newValue) {
        if (!Array.isArray(newValue)) {
            return;
        }
        var newStartYear = newValue[0], newEndYear = newValue[1];
        onYearChange(newStartYear, newEndYear);
    };
    var rangeLabel = rangeLabelFormat(value[0], value[1]);
    return (_jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "body2", sx: { fontSize: '0.8125rem', mb: 1, mx: 'auto' } }, { children: rangeLabel })), _jsx(Slider, { value: value, onChange: handleChange, onChangeCommitted: handleChangeCommitted, valueLabelDisplay: valueLabelDisplay, valueLabelFormat: valueLabelFormat, min: minYear, max: maxYear, step: 1, marks: marks, disabled: disabled, sx: combinedSliderStyles })] }));
};
